<div class="h-full flex flex-col justify-start items-center overflow-hidden space-y-4">



    <!-- Header -->
    <div
      class="flex-0 flex flex-row items-center justify-between w-full border-b border-zinc-200 dark:border-zinc-800 pb-2">
  
      <div class="shrink-0 flex flex-row items-center justify-start gap-x-4 sm:gap-x-6">
        <button (click)="exit()" type="button" class="fab-button-secondary">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5">
            <path d="m12 19-7-7 7-7" />
            <path d="M19 12H5" />
          </svg>
        </button>
  
        <div class="">
          <div class="inline-flex items-center gap-x-2">
            <h3 class="text-md font-semibold text-primary">Create Screening Brief
            </h3>
            <!-- <span
              class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset">Text</span> -->
          </div>
          <p class="mt-0 text-xs text-secondary">Creator Screening</p>
        </div>
      </div>
  
      <div class="flex flex-row items-center justify-end gap-x-4">
        @if (screen() !== 'chooser') {
        <button type="button" class="secondary-button" (click)="switchFlow()">Switch flow</button>
        }
      </div>
  
    </div>
    <!-- Header - END-->
  
    <!-- Main Section -->
    <div class="h-full flex-1 flex-col items-center justify-center w-full overflow-hidden">
      @switch (screen()) {
      @case ('chooser') {
      <sbs-flow-chooser-screening (choose)="chooseFlow($event)" />
      }
      @case ('wizard') {
       <sbs-wizard-first-screening (launch)="submit()" />
      }
      @case ('ai') {
      <sbs-ai-first-screening (launch)="submit()" (startOver)="startOver()" />
      }
      }
    </div>
    <!-- Main Section - END -->
  
  </div>
  
  @if (submitStage() !== 'idle') {
  <sbs-screening-overlay [stages]="submitStages" headIcon="send" headline="Submitting Brief" subLead="Sending"
    [subject]="briefName()" subTrail="to the SHOUT screening engine…" [result]="overlayResult()" passIcon="check-check"
    resultTitle="Brief Submitted." [resultSub]="briefName() + ' ' + submittedSub()">

    <div overlayActions class="contents">
      <button type="button" class="flashy-go-button" (click)="openManageBrief()">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4"
          aria-hidden="true">
          <path d="M14 17H5" />
          <path d="M19 7h-9" />
          <circle cx="17" cy="17" r="3" />
          <circle cx="7" cy="7" r="3" />
        </svg>
        Manage Brief
      </button>
      <button type="button" (click)="goHome()"
        class="inline-flex items-center gap-2 rounded-full border border-white/40 px-5 py-2.5 text-sm font-bold text-white/90 transition-colors hover:border-white hover:bg-white/10 hover:text-white">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8" />
          <path d="M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
        </svg>
        Go Back Home
      </button>
    </div>
  </sbs-screening-overlay>
  }